"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCheckboxes = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * Set the consent status for some purposes using the purpose ID.
 */
function setCheckboxes(checkboxesStatus) {
    (0, get_zaraz_1.getZaraz)().consent.setCheckboxes(checkboxesStatus);
}
exports.setCheckboxes = setCheckboxes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0LWNoZWNrYm94ZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc2VudC9zZXQtY2hlY2tib3hlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxvREFBZ0Q7QUFFaEQ7O0dBRUc7QUFDSCxTQUFnQixhQUFhLENBQUMsZ0JBRTdCO0lBQ0MsSUFBQSxvQkFBUSxHQUFFLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDO0FBQ3JELENBQUM7QUFKRCxzQ0FJQyJ9